import striptags from 'striptags';

import type { SafetyHelmetProps } from 'src/components/SafetyHelmet/SafetyHelmet';
import { useBrandName } from 'src/hooks/useBrandName';
import { useMelwaysCountry } from 'src/utils/melwaysHelper';

import { generateMetaDescription, generateMetaTitle } from '../utils';

import { useJobDetailsHeadTitle } from './title';

interface JobDetailsHeadProps {
  jobTitle: string;
  location: string;
  abstract: string;
  normalisedRoleTitle: string;
  broaderLocationName: string;
  normalisedOrganisationName: string;
}

export const useJobDetailsHead = ({
  jobTitle,
  location,
  abstract,
  normalisedRoleTitle,
  broaderLocationName,
  normalisedOrganisationName,
}: JobDetailsHeadProps): SafetyHelmetProps => {
  const brand = useBrandName();
  const country = useMelwaysCountry();
  const jobsInLocation = location ? ` Job in ${location}` : '';
  const normalisedTitle = useJobDetailsHeadTitle({
    brand,
    normalisedRoleTitle,
    broaderLocationName,
    normalisedOrganisationName,
  });
  const title = `${jobTitle}${jobsInLocation} - ${brand}`;

  return {
    // Only use normliased title in markets where Google for Jobs is enabled
    title: country === 'sg' || country === 'ph' ? normalisedTitle : title,
    meta: [
      ...generateMetaTitle(title),
      ...generateMetaDescription(striptags(abstract)),
    ],
  };
};
